import { ReactElement } from 'react'

import { IPlace, ISelectPlacesProps } from 'features/Places/components/SelectPlaces/types'
import { SelectTags } from 'components/v2/SelectTags'

export const SelectPlaces = ({
  places = [],
  values = [],
  onChange,
  onBlur,
  id,
  label,
  placeholder,
  errors,
  touched
}: ISelectPlacesProps): ReactElement => {
  const sortedItems = [...places].sort((a, b) => a.name.localeCompare(b.name))

  const handleChange = (places: IPlace[]): void => {
    onChange(places)
  }

  return (
    <SelectTags
      id={id}
      placeholder={placeholder}
      values={values}
      label={label}
      items={sortedItems}
      getTagLabel={(place: IPlace): string => place.name}
      onChange={handleChange}
      onBlur={onBlur}
      touched={touched}
      errors={errors}
    />
  )
}
